import { render, staticRenderFns } from "./PaymentFailed.vue?vue&type=template&id=5ac110e2&scoped=true&"
import script from "./PaymentFailed.vue?vue&type=script&lang=ts&"
export * from "./PaymentFailed.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentFailed.vue?vue&type=style&index=0&id=5ac110e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac110e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
